import { createReducer, on } from '@ngrx/store';
import { ArticleStatusState } from '@products/models/article.model';
import { ResetProductsActions } from '@store/products/product.actions';
import { ArticleStatusActions } from '@store/products/status/article/article-status.actions';

export { ArticleStatusState as State };

export const initialState: ArticleStatusState = null;

export const articleStatusReducer = createReducer(
  initialState,
  on(ArticleStatusActions.resetReducer, ResetProductsActions.resetStatusReducer, () => initialState)
);
